export default __webpack_public_path__ + "static/media/gear-wheel-310906.adde8609.png";